module.exports = __webpack_public_path__ + "img/emoji_013.b820ef1f.png";